<template>
  <el-date-picker
    v-on="inputListeners"
    :class="computedDatePickerClass"
    v-model="$attrs.value"
    :type="$attrs.type ? $attrs.type : 'daterange'"
    align="center"
    size="mini"
    :popper-class="`er-date-picker-popper ${$attrs['popper-class'] || ''}`"
    :format="$attrs.format || DATE_OBJ_DATE_FORMAT_WITH_YEAR"
    :unlink-panels="$attrs['unlink-panels'] || true"
    :range-separator="$t('Comn_to')"
    :start-placeholder="$t('Comm_Start')"
    :end-placeholder="$t('Comn_End')"
    :value-format="
      $attrs['value-format'] || $commonUtils.DATE_OBJ_DATE_VALUE_FORMAT
    "
    :picker-options="pickerOptions"
    :clearable="$attrs.clearable || false"
    :disabled="$attrs.disabled || false"
  ></el-date-picker>
</template>

<script>
import { DATE_OBJ_DATE_FORMAT_WITH_YEAR } from "@/utils/commonUtils";
export default {
  created() {
    this.dateRange = this.$attrs.value;
  },

  inheritAttrs: false,
  computed: {
    inputListeners: function() {
      var vm = this;
      // `Object.assign` merges objects together to form a new object
      return Object.assign(
        {},
        // We add all the listeners from the parent
        this.$listeners,
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        {
          // This ensures that the component works with v-model
          input: function(event) {
            vm.$emit("input", event);
          }
        }
      );
    },
    computedDatePickerClass: function() {
      const classList = ["date-picker"];
      if (!this.$attrs.clearable) {
        classList.push("hide-clear-icon");
      }
      return classList.join(" ");
    },
    pickerOptions() {
      if (
        this.$attrs["picker-options"] &&
        Object.keys(this.$attrs["picker-options"]).length > 0
      ) {
        return this.$attrs["picker-options"];
      } else {
        return {
          disabledDate:
            this.$attrs.disableDateMethod ||
            (time => {
              return time.getTime() > Date.now();
            }),
          shortcuts: [
            {
              no: 1,
              unit: "days",
              text: this.$t("Comn_yesterday"),
              type: "date"
            },
            { no: 6, unit: "days", text: this.$t("last_7days"), type: "date" },
            {
              no: 14,
              unit: "days",
              text: this.$t("last_15days"),
              type: "date"
            },
            {
              no: 1,
              unit: "months",
              text: this.$t("last_30days"),
              type: "date"
            },
            {
              no: 3,
              unit: "months",
              text: this.$t("last_3months"),
              type: "date"
            },
            {
              no: 6,
              unit: "months",
              text: this.$t("last_6months"),
              type: "date"
            }
          ].map(shortCut => {
            return {
              text: shortCut.text,
              onClick: picker => {
                if (shortCut.type === "control") {
                } else {
                  const end = this.$moment();
                  const start = this.$moment();
                  start.subtract(shortCut.no, shortCut.unit);
                  picker.$emit("pick", [start.toDate(), end.toDate()]);
                }
              }
            };
          })
        };
      }
    }
  },
  data: function() {
    return {
      dateRange: [new Date(), new Date()],
      DATE_OBJ_DATE_FORMAT_WITH_YEAR
    };
  },
  methods: {
    handleValueChange: function(event) {}
  }
};
</script>

<style lang="scss">
@mixin input-font-size {
  @include responsiveProperty(
    font-size,
    $app_font_size_small,
    $app_font_size_1,
    $app_font_size_2
  );
}
.el-date-table {
  @include input-font-size;
}
.er-date-picker-popper {
  .el-picker-panel__sidebar {
    width: 120px;
  }
  .el-picker-panel__shortcut {
    @include responsiveProperty(
      font-size,
      $app_font_size_small,
      $app_font_size_1,
      $app_font_size_2
    );
  }
}
.el-range-editor--mini .el-range-separator {
  @include input-font-size;
  width: 10%;
}
.el-picker-panel__footer {
  border-top: 1px solid #e4e4e4;
  padding: 4px;
  text-align: right;
  background-color: #fff;
  position: relative;
  font-size: 0;
  margin-left: 110px;
}
.date-picker {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  &.el-date-editor--daterange.el-input,
  &.el-date-editor--daterange.el-input__inner,
  &.el-date-editor--timerange.el-input,
  &.el-date-editor--datetimerange.el-input,
  &.el-date-editor--datetimerange.el-input__inner,
  &.el-date-editor--timerange.el-input__inner {
    width: 100%;
  }

  &.el-range-editor.el-input__inner {
    align-items: baseline;
    padding: 5px 10px;
  }
  &.el-date-editor .el-range-input,
  &.el-input__inner,
  &.el-date-editor .el-range-separator {
    line-height: unset;
    height: unset;
  }
  .el-range__close-icon,
  .el-range__icon {
    line-height: unset;
  }
  &.el-date-editor .el-range__icon {
    @include icon-size(icon-font, prefix);
  }
  .el-range-input {
    @include input-font-size;
    width: 45%;
    // @include responsiveProperty(padding-bottom, 0px, 1px, 1px);
  }
  &.hide-clear-icon {
    .el-range__close-icon {
      display: none;
    }
  }
}
</style>
